import React from 'react';
import { Box } from '../../types-hack';

interface IProps {
  url?: string;
  base64Content?: string;
  style?: React.CSSProperties;
}

/**
 * A wrapper around dynamic displaying of svg's (https://stackoverflow.com/questions/8499633/how-to-display-base64-images-in-html)
 * @param param0
 * @returns
 */
const SvgDisplay: React.FC<IProps> = ({ url, base64Content, style }: IProps) => {
  return (
    <Box p={5}>
      <img style={style} src={url ? url : `data:image/svg+xml;base64, ${base64Content!}`} />
    </Box>
  );
};

export default SvgDisplay;
